import { render } from "./BenefitDetailModal.vue?vue&type=template&id=54267bc4&scoped=true"
import script from "./BenefitDetailModal.vue?vue&type=script&lang=js"
export * from "./BenefitDetailModal.vue?vue&type=script&lang=js"

import "./BenefitDetailModal.vue?vue&type=style&index=0&id=54267bc4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54267bc4"]])

export default __exports__